export enum EUsersRoutes {
    PermissionManagement = 'permission-management',
}
